<template>
  <div class="myCheck">
    <div :class="checked ? ['checkBox', 'checked'] : 'checkBox'" @click='handleClick'></div>
    <p class="label">{{ $t('productList.all') }}</p>
  </div>
</template>

<script>
export default {
  props: {
    categoryId: {
      type: String,
      default: ''
    }
  },
  computed: {
    checked() {
      return this.$store.state.checkedAllCategoryId === this.categoryId
    }
  },
  methods: {
    handleClick: function () {

      this.$nextTick(() => {
        if (!this.checked) {
          this.$store.commit('setCheckedAllCategoryId', this.categoryId)
        } else {
          this.$store.commit('clearCheckedAllCategoryId')
        }

        this.$emit('checkedAllData', this.checked)
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.myCheck {
  display: flex;
  align-items: center;
  margin: 10px 0;

  .checkBox {
    width: 10px;
    height: 10px;
    border: 2px solid rgba(225, 225, 225, 1);
    display: inline-block;
    line-height: 200%;
    background: #fff;
    transition: all 0.4s;
    margin-right: 8px;
    cursor: pointer;
  }

  .checkBox.checked {
    background: #2E79D0;
  }

  .label {
    font-size: 12px;
    // font-weight: 600
  }
}
</style>
